require("./bootstrap");
require("bootstrap");
require("./instant_search");
require("./footnotes");
require("./menu");
require("./chat");
require("fslightbox");
require("select2");

import anime from "animejs/lib/anime.es.js";

var app = (function () {
    var _seachform_isInit = false;
    var _seachform_params = [];
    const api = "/api";

    const device = function () {
        var width = Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
        );
        if (width > 1200) return "desktop";
        else if (width >= 800) return "tablet";
        else return "mobile";
    };

    function scrollToTop() {
        var rootElement = document.documentElement;
        rootElement.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }

    // $.fn.selectText = function(){
    //     this.find('input').each(function() {
    //         if($(this).prev().length == 0 || !$(this).prev().hasClass('p_copy')) {
    //             $('<p class="p_copy" style="position: absolute; z-index: -1;"></p>').insertBefore($(this));
    //         }
    //         $(this).prev().html($(this).val());
    //     });
    //     var doc = document;
    //     var element = this[0];
    //     console.log(this, element);
    //     if (doc.body.createTextRange) {
    //         var range = document.body.createTextRange();
    //         range.moveToElementText(element);
    //         range.select();
    //     } else if (window.getSelection) {
    //         var selection = window.getSelection();
    //         var range = document.createRange();
    //         range.selectNodeContents(element);
    //         selection.removeAllRanges();
    //         selection.addRange(range);
    //     }
    // };

    $.validator.setDefaults({
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.addClass("invalid-feedback");
            element.closest(".form-group").append(error);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass("is-invalid");
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass("is-invalid");
        },
    });

    const clearForm = () => {
        document.querySelector("form").reset();
        $('form input[type="text"]').val("");
        $('form input[name="exact-match"]').prop("checked", false);
        $('form input[name="category[]"]').prop("checked", false);
        $('form input[name="category[]"][value="1"]').prop("checked", true);

        $('form select[name="article_topic_id[]"]').val(0);
        $('form select[name="article_type_id[]"]').val(0);

        update_cat();
        get_sub_category();
        get_articles_sub_sub_category();
        get_articles_topic();
    };

    let cat = [];

    var init_toc = function () {
        if (device() == "mobile") {
            var sidebar = $(".sidebar__inner");
            $(".off-canvas-menu").append(`
                <div id="menu-toc">
                    <div class="menu-toc-inner"></div>
                </div>
            `);
            sidebar.clone().appendTo(".menu-toc-inner");
            sidebar.empty();
        }
    };

    var preferencesGets = function () {
        if (user_id > 0) {
            $.ajax(api + "/preference/gets", {
                method: "POST",
                data: {
                    user_id: user_id,
                },
                success: function (res) {
                    res.map((article) => {
                        $(
                            ".add-favorite[data-target='" + article.id + "']"
                        ).addClass("is-favorite");
                        $(".add-favorite[data-target='" + article.id + "']")
                            .find("i")
                            .removeClass("far")
                            .addClass("fa");
                    });
                },
            });
        }
    };

    var stickyMenu = function () {
        if ($(".sidebar").length && device() != "mobile") {
            var sidebar = new StickySidebar(".sidebar", {
                topSpacing: 80,
                innerWrapperSelector: ".sidebar__inner",
            });
        }
    };

    /** open menu **/
    var open_menu = function () {
        $(".hamburger").addClass("is-active");
        anime({
            targets: ".off-canvas-menu",
            visibility: "visible",
            opacity: 1,
            easing: "easeInOutSine",
            duration: 300,
            begin: function () {
                document.querySelector(".off-canvas-menu").style.display =
                    "block";
            },
            complete: function (anim) {
                if (anim.completed) {
                    anime({
                        targets: "#menu-mobile",
                        right: 0,
                        easing: "easeOutSine",
                        duration: 600,
                    });
                }
            },
        });
    };

    /** close menu **/
    var close_menu = function () {
        var w = $("#menu-mobile").width();
        $(".hamburger").removeClass("is-active");
        anime({
            targets: "#menu-mobile",
            right: "-" + w,
            easing: "easeInOutSine",
            duration: 600,
            complete: function (anim) {
                if (anim.completed) {
                    anime({
                        targets: ".off-canvas-menu",
                        opacity: 0,
                        easing: "easeInOutSine",
                        duration: 300,
                        complete: function (anim) {
                            if (anim.completed) {
                                document.querySelector(
                                    ".off-canvas-menu"
                                ).style.display = "none";
                            }
                        },
                    });
                }
            },
        });
    };

    /** open toc **/
    var open_toc = function () {
        anime({
            targets: ".off-canvas-menu",
            visibility: "visible",
            opacity: 1,
            easing: "easeInOutSine",
            duration: 300,
            begin: function () {
                document.querySelector(".off-canvas-menu").style.display =
                    "block";
            },
            complete: function (anim) {
                if (anim.completed) {
                    anime({
                        targets: "#menu-toc",
                        left: 0,
                        easing: "easeOutSine",
                        duration: 600,
                    });
                }
            },
        });
    };

    var close_toc = function () {
        var w = $("#menu-toc").width();
        anime({
            targets: "#menu-toc",
            left: "-" + w,
            easing: "easeInOutSine",
            duration: 600,
            complete: function (anim) {
                if (anim.completed) {
                    anime({
                        targets: ".off-canvas-menu",
                        opacity: 0,
                        easing: "easeInOutSine",
                        duration: 300,
                        complete: function (anim) {
                            if (anim.completed) {
                                document.querySelector(
                                    ".off-canvas-menu"
                                ).style.display = "none";
                            }
                        },
                    });
                }
            },
        });
    };

    function get_sub_category() {
        console.log(cat);
        if (cat.includes("3")) {
            $('[name="sub_category_id"]')
                .parents("fieldset")
                .prop("disabled", false);
            $('[name="sub_sub_category_id"]')
                .parents("fieldset")
                .prop("disabled", false);            
        } else {
            $('[name="sub_category_id"]')
                .parents("fieldset")
                .prop("disabled", true);
            $('[name="sub_sub_category_id"]')
                .parents("fieldset")
                .prop("disabled", true);
        }
    };

    var update_cat = function () {
        var checked = $('[name="category[]"]:checked');
        cat = [];
        checked.each(function () {
            cat.push($(this).val());
        });
    };

    var get_articles_topic = function (topic_id) {
        if (user_id > 0) {
            $.ajax(api + "/article/topics", {
                method: "POST",
                type: "json",
                data: {
                    article_categories_ids: cat,
                    portal: "fisco",
                },
                success: function (res) {
                    if (res) {
                        var sel = $('[name="article_topic_id[]"]');
                        sel.empty();
                        sel.append('<option value="0">Seleziona argomento</option>');
                        $.each(res, function (k, e) {
                            sel.append(
                                '<option value="' +
                                    e.id +
                                    '">' +
                                    e.name +
                                    "</option>"
                            );
                        });

                        // reinit
                        if ($("#article_topic_id").data("select2")) {
                            $("#article_topic_id").select2("destroy");
                        }
                        initSelectMultiple();
                    }
                },
            });
        }
    };

    var get_articles_sub_sub_category = function (sub_category_id) {
        if (user_id > 0) {
            $.ajax(api + "/article/subSubCategory", {
                method: "POST",
                type: "json",
                data: {
                    article_sub_categories_id: sub_category_id,
                },
                success: function (res) {
                    if (res) {
                        var sel = $('[name="sub_sub_category_id"]');
                        sel.empty();
                        sel.append('<option value="0">Comune</option>');
                        $.each(res, function (k, e) {
                            sel.append(
                                '<option value="' +
                                    e.id +
                                    '">' +
                                    e.name +
                                    "</option>"
                            );
                        });

                        if (topic_id) {
                            sel.val(topic_id);
                        }
                        // reinit
                        if ($("#article_topic_id").data("select2")) {
                            $("#article_topic_id").select2("destroy");
                        }
                        initSelectMultiple();
                    }
                },
            });
        }

    };

    // var scroll = new SmoothScroll('a[href*="#"]', {
    //     updateURL: true,
    //     popstate: true,
    //     header: '.navbar-wrapper'
    // });

    var logScrollEvent = function (event) {
        // The event type
        console.log("type:", event.type);

        // The anchor element being scrolled to
        console.log("anchor:", event.detail.anchor);

        // The anchor link that triggered the scroll
        console.log("toggle:", event.detail.toggle);
    };

    document.addEventListener("scrollStart", logScrollEvent, false);
    document.addEventListener("scrollStop", logScrollEvent, false);
    document.addEventListener("scrollCancel", logScrollEvent, false);

    const advanceSearchToggle = () => {
        const formEnd = $(".form-end");
        if (!formEnd.hasClass("open")) {
            $(".form-end").slideDown();
            $(".form-end").addClass("open");
            $(".toolbar-advance-ctr .icon").css({
                transform: "rotate(180deg)",
            });
        } else {
            $(".form-end").slideUp();
            $(".form-end").removeClass("open");
            $(".toolbar-advance-ctr .icon").css({
                transform: "rotate(0deg)",
            });
        }
    };

    const wave = () => {
        const wave1 = wavify(document.querySelector("#wave1"), {
            height: 60,
            bones: 5,
            amplitude: 40,
            color: "rgba(256, 256, 256, .15)",
            speed: 0.15,
        });
        const wave2 = window.wavify(document.querySelector("#wave2"), {
            height: 60,
            bones: 3,
            amplitude: 40,
            color: "rgba(256, 256, 256, .20)",
            speed: 0.25,
        });
        const wave3 = window.wavify(document.querySelector("#wave3"), {
            height: 60,
            bones: 3,
            amplitude: 40,
            color: "rgba(256, 256, 256, .25)",
            speed: 0.3,
        });
        const wave4 = window.wavify(document.querySelector("#wave4"), {
            height: 60,
            bones: 3,
            amplitude: 40,
            color: "rgba(256, 256, 256, .30)",
            speed: 0.35,
        });
        const wave5 = window.wavify(document.querySelector("#wave5"), {
            height: 60,
            bones: 1,
            amplitude: 70,
            color: "rgba(256, 256, 256, 1)",
            speed: 0.5,
        });
    };

    var init_search_form = function () {
        if ($(".form-search").length && _seachform_isInit === false) {
            _seachform_params = JSON.parse(search_parms) || [];
            _seachform_isInit = true;
            var topic_id = _seachform_params.article_topic_id || null;
            var sub_category = _seachform_params.sub_category_id || null;
            update_cat();
            get_articles_topic(topic_id);
            get_sub_category();
            get_articles_sub_sub_category(sub_category);
        }
    };

    const init = () => {
        wave();
        preferencesGets();
        stickyMenu();
        init_toc();
        initSelectMultiple();
        init_search_form();
    };

    // cache the navigation links
    var $navigationLinks = $("#article-nav a");
    // cache (in reversed order) the sections
    var $sections = $($(".article-item").get().reverse());

    // map each section id to their corresponding navigation link
    var sectionIdTonavigationLink = {};
    $sections.each(function () {
        var id = $(this).attr("id");
        sectionIdTonavigationLink[id] = $("#article-nav a[href=\\#" + id + "]");
    });

    // throttle function, enforces a minimum time interval
    // function throttle(fn, interval) {
    //     var lastCall, timeoutId;
    //     return function () {
    //         var now = new Date().getTime();
    //         if (lastCall && now < (lastCall + interval) ) {
    //             // if we are inside the interval we wait
    //             clearTimeout(timeoutId);
    //             timeoutId = setTimeout(function () {
    //                 lastCall = now;
    //                 fn.call();
    //             }, interval - (now - lastCall) );
    //         } else {
    //             // otherwise, we directly call the function
    //             lastCall = now;
    //             fn.call();
    //         }
    //     };
    // }

    // function highlightNavigation() {
    //     var scrollPosition = $(window).scrollTop() - $('.navbar-wrapper').height() - 40;
    //
    //     // iterate the sections
    //     $sections.each(function() {
    //         var currentSection = $(this);
    //
    //         // get the position of the section
    //         var sectionTop = currentSection.offset().top;
    //
    //         // if the user has scrolled over the top of the section
    //         if (scrollPosition >= sectionTop) {
    //             // get the section id
    //             var id = currentSection.attr('id');
    //             // get the corresponding navigation link
    //             var $navigationLink = sectionIdTonavigationLink[id];
    //             // if the link is not active
    //             if (!$navigationLink.hasClass('active')) {
    //                 $navigationLinks.removeClass('active');
    //                 $navigationLink.addClass('active');
    //                 var pos = $navigationLink.offset();
    //                 if(pos !== undefined) {
    //                     $('.menu-list').scrollTop(pos.top + 60);
    //                 } else {
    //                     $('.menu-list').scrollTop(0);
    //                 }
    //             }
    //             // we have found our section, so we return false to exit the each loop
    //             return false;
    //         }
    //     });
    // }

    function checkoutUpdate() {
        const url = api + "/checkout/update";
        const coupon = $('input[name="coupon"]').val();
        const pack = $("input[name=package]:checked").val();
        console.log(pack);
        $.ajax(url, {
            method: "POST",
            data: {
                user_id: user_id,
                coupon: coupon,
                package: pack,
            },
            success: function (res) {
                if (res.total > 0) {
                    console.log(parseFloat(res.total));
                    $(".total").html(
                        parseFloat(res.total).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                        }) + " €"
                    );
                }
            },
        });
    }

    function subscriptionSearchTracker() {
        const url = api + "/user/subscription/search/counter";
        const params = { user_id: user_id };
        return $.ajax(url, {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
                Authorization:
                    "Bearer " + $('meta[name="api_token"]').attr("content"),
            },
            data: params,
        });
    }

    function showModalCol(idCol) {
        var content = $("#collsable-" + idCol).html();
        $("#modal-collapse").find("h5").html("Testo storico");
        $("#modal-collapse").find(".modal-body").html(content);
        $("#modal-collapse").modal("toggle");

        $('[data-toggle="tooltip"]').tooltip("dispose");
        $('[data-toggle="tooltip"]').tooltip();
    }

    function initSelectMultiple() {
        $("#article_topic_id").select2({
            theme: "bootstrap4",
            placeholder: $(this).data("placeholder"),
        });

        $("#article_type_id").select2({
            theme: "bootstrap4",
            placeholder: $(this).data("placeholder"),
        });
    }

    init();

    $("document").ready(() => {
        $("form").validate({
            focusInvalid: false,
        });

        var scrollToTopBtn = $("#scrollToTopBtn");

        $(document).scroll(function () {
            var y = $(this).scrollTop();
            if (y > 800) {
                scrollToTopBtn.fadeIn();
            } else {
                scrollToTopBtn.fadeOut();
            }
        });

        scrollToTopBtn.click(function () {
            scrollToTop();
        });

        $(".toolbar-advance-ctr").on("click", function () {
            advanceSearchToggle();
        });

        $(".toolbar-clear-ctr").on("click", function () {
            clearForm();
        });

        // add favorite
        $(".add-favorite").on("mouseover", function () {
            if (!$(this).hasClass("is-favorite")) {
                $(this).find("i").removeClass("far").addClass("fa");
            }
        });

        $(".add-favorite").on("mouseout", function () {
            if (!$(this).hasClass("is-favorite")) {
                $(this).find("i").removeClass("fa").addClass("far");
            }
        });

        $(".add-favorite").on("click", function (e) {
            e.preventDefault();
            var _this = this;
            var article_id = $(this).attr("data-target");
            if (user_id > 0) {
                $.ajax(api + "/preference", {
                    method: "POST",
                    data: {
                        user_id: user_id,
                        article_id: article_id,
                    },
                    success: function (res) {
                        $(_this).toggleClass("is-favorite");
                    },
                });
            }
        });

        $(".carousel").slick();

        $('[name="category[]"]').on("change", function () {
            update_cat();
            get_articles_topic();
            get_sub_category();
            get_articles_sub_sub_category();
        });

        $('[name="sub_category_id"]').on("change", function () {
            get_articles_sub_sub_category($(this).val());
        });

        $('[name="sort"]').on("change", function () {
            var sort = $(this).val();
            var url = new URL(window.location.href);
            url.searchParams.set("sort", sort);
            window.location.href = url;
        });

        $(".ctrl-mobilemenu").on("click", function (e) {
            if ($(this).hasClass("is-active")) {
                close_menu();
            } else {
                open_menu();
            }
            e.preventDefault();
        });

        $(".ctrl-toc").on("click", function (e) {
            e.preventDefault();
            open_toc();
        });

        $(".menu-toc-inner li a").on("click", function (e) {
            close_toc();
        });

        $(".btn-print").on("click", function () {
            window.print();
        });

        // $(window).scroll( throttle(highlightNavigation,100) );

        $(".slider-article").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        $('input[name="package"]').on("change", function () {
            checkoutUpdate();
        });

        $("#checkout-update").on("click", function (e) {
            e.preventDefault();
            checkoutUpdate();
        });

        $('[data-toggle="tooltip"]').tooltip();

        $(".form-search").on("submit", function (e) {
            e.preventDefault();
            var _this = $(this);
            $.when(subscriptionSearchTracker()).then(function () {
                _this.unbind("submit").submit();
            });
        });

        $(".collsable-trigger").on("click", function (e) {
            e.preventDefault();
            var idCol = $(this).attr("data-collapse") || 0;
            showModalCol(idCol);
        });

        $(".content img").on("click", function (e) {
            e.preventDefault();
            var src = $(this).attr("src");
            var filename = src
                .replace(/^.*[\\\/]/, "")
                .replace(/\.[^/.]+$/, "");
            var url = api + "/media/" + filename;
            $.ajax(url, {
                method: "POST",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content"
                    ),
                    Authorization:
                        "Bearer " + $('meta[name="api_token"]').attr("content"),
                },
                success: function (res) {
                    if (res) {
                        $("#modal-attach")
                            .find(".modal-body")
                            .html(
                                '<img src="' +
                                    res.original.url +
                                    '" class="img-fluid">'
                            );
                        $("#modal-attach .modal-header ul").empty();
                        $("#modal-attach .modal-header ul").append(
                            '<li><a href="' +
                                res.original.print +
                                '" class="attach-print"><i class="fas fa-print"></i> Stampa</a></li>'
                        );

                        if (res.original) {
                            $("#modal-attach .modal-header ul").append(
                                '<li><a href="' +
                                    res.original.download +
                                    '" target="_blank"><i class="far fa-file-image"></i> Download Immagine</a></li>'
                            );
                        }

                        if (res.pdf) {
                            $("#modal-attach .modal-header ul").append(
                                '<li><a href="' +
                                    res.pdf.download +
                                    '" target="_blank"><i class="far fa-file-pdf"></i> Download PDF</a></li>'
                            );
                        }
                        if (res.dwg) {
                            $("#modal-attach .modal-header ul").append(
                                '<li><a href="' +
                                    res.dwg.download +
                                    '" target="_blank"><i class="far fa-file"></i> Download DWG</a></li>'
                            );
                        }

                        $("#modal-attach").modal("show");
                    }
                },
            });
        });
        refreshFsLightbox();
    });

    $("body").on("click", ".attach-print", function (e) {
        e.preventDefault();

        var image = $("#modal-attach .modal-body").html();
        var printPopup = window.open(
            "",
            "",
            "height=400,width=800,scrollbars=1,menubar=1"
        );
        printPopup.document.write("<html>");
        printPopup.document.write("<head>");
        printPopup.document.write("</head><body >");
        printPopup.document.write(image);
        printPopup.document.write("</body></html>");

        var is_chrome = function () {
            return Boolean(window.chrome);
        };
        if (is_chrome) {
            setTimeout(function () {
                // wait until all resources loaded
                printPopup.document.close(); // necessary for IE >= 10
                printPopup.focus(); // necessary for IE >= 10
                printPopup.print(); // change window to winPrint
                printPopup.close(); // change window to winPrint
            }, 250);
        } else {
            printPopup.print();
            printPopup.document.close();
        }
    });
})();
